<template>
  <div class="regra-produto">
    <label>
      {{ label }}
      <span
        v-if="hint"
        class="dropdown-hint-icon ml-1"
        :data-tooltip="hint"
      >
        <fa-icon icon="info-circle" />
      </span>
    </label>
    <input
        type="text"
        v-model="inputValue"
        class="form-control"
        @input="fetchProdutos"
        @focus="onFocus"
        @blur="hideDropdown"
        :disabled="disabled"
        placeholder="Código ou descrição do produto..."
    />

    <div v-if="showDropdown && produtos.length" class="dropdown-menu show" style="position: absolute;">
      <div
          v-for="produto in produtos"
          :key="produto.id"
          class="dropdown-item"
          @mousedown="selectProduto(produto)"
      >
        {{ produto.id + ' - ' + produto.descNF }}
      </div>
    </div>
  </div>
</template>

<script>
import _debounce from 'lodash/debounce';
import { get } from "@/helpers/apiRequest";

export default {
  name: 'DropdownInput',
  props: {
    value: String,
    label: String,
    field: String,
    index: Number,
    disabled: Boolean,
    hint: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      produtos: [],
      showDropdown: false,
      inputValue: this.value,
      debouncedSearch: _debounce(this.loadProdutos, 500)
    };
  },
  methods: {
    onFocus() {
      this.showDropdown = true;
      this.loadProdutos(this.inputValue || '');
    },
    fetchProdutos(event) {
      const term = event.target.value;
      this.debouncedSearch(term);
    },
    selectProduto(produto) {
      this.$emit('input', produto.id);
      this.showDropdown = false;
    },
    hideDropdown() {
      setTimeout(() => {
        this.showDropdown = false;
      }, 200);
    },
    loadProdutos(termo = '') {
      return get(`/admin/campanhas-produtos-paginados?termo=${termo}&take=48`)
          .then((json) => {
            this.produtos = json.itens;
          });
    }
  },
  watch: {
    value(newValue) {
      this.inputValue = newValue;
    }
  }
};
</script>

<style scoped>
.dropdown-menu {
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  z-index: 1000;
  border: 1px solid #ddd;
}

.dropdown-item {
  padding: 10px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

.regra-produto {
  position: relative;
  margin-right: 16px;
}

.regra-produto label {
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
}

.dropdown-hint-icon {
  position: relative;
  color: #aaa;
  cursor: help;
  font-size: 11px;
  display: inline-flex;
  align-items: center;
}

.dropdown-hint-icon:hover {
  color: #0056b3;
}

.dropdown-hint-icon::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  font-size: 11px;
  font-weight: normal;
  line-height: 1.5;
  padding: 6px 10px;
  border-radius: 4px;
  width: 240px;
  white-space: normal;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.1s ease;
  z-index: 9999;
}

.dropdown-hint-icon:hover::after {
  opacity: 1;
}
</style>
